import { Mutations, Actions, Module, Context } from 'vuex-smart-module'

import { Store } from 'vuex'

import { loading as loadingModule, LoadingGetters } from '@/store/modules/loading'
import { EsiaService } from '@/api'
import { security } from '@/store/modules/security'

const loading = loadingModule.clone()

class ESIAState {}

class ESIAGetters extends LoadingGetters<ESIAActions, ESIAState> {
  get isRedirectLinkGet() {
    return this.state.loading.loaders.getRedirectLink
  }

  get isLogin() {
    return this.state.loading.loaders.login
  }
}

class ESIAMutations extends Mutations<ESIAState> {}

class ESIAActions extends Actions<ESIAState, ESIAGetters, ESIAMutations, ESIAActions> {
  securityModule!: Context<typeof security>

  $init(store: Store<unknown>) {
    this.securityModule = security.context(store)
  }

  async getRedirectLink() {
    return await EsiaService.redirect()
  }

  async login({ state, code }: { state: string; code: string }) {
    try {
      const user = await EsiaService.authenticate({ state, code })
      this.securityModule.mutations.setUser(user)
    } catch (error) {
      this.securityModule.mutations.setError()
      throw error
    }
  }
}

export type ESIAModules = {
  loading: typeof loading
}

export const esia = new Module<ESIAState, ESIAGetters, ESIAMutations, ESIAActions, ESIAModules>({
  modules: { loading },
  state: ESIAState,
  getters: ESIAGetters,
  mutations: ESIAMutations,
  actions: ESIAActions,
})
